import React, { ReactElement, useCallback, useState } from 'react';

import { request } from 'app/utils';
import { useSchool } from 'features/school';

import { AgreementItemState, useAgreements, AgreementsApiResponse } from 'features/agreements';
import { Button, Checkbox, Flex, RichContent, Typography } from 'components';
import { AxiosResponse } from 'axios';

const AgreementContent = (): ReactElement => {
  const [acceptedTerm, setAcceptedTerm] = useState(false);
  const [errorAcceptedTerm, setErrorAcceptedTerm] = useState(false);

  const { apiGatewayUrl } = useSchool();
  const { setAgreements } = useAgreements();

  const { agreements, agreementsCount, showAgreementProductSlug, showAgreementProductClassUuid, clearShowAgreement } = useAgreements();

  const agreement: AgreementItemState | null =
    (showAgreementProductSlug && showAgreementProductClassUuid && agreements[showAgreementProductSlug][showAgreementProductClassUuid]) || null;

  const reFetch = () => {
    request({
      url: `/api/v1/School/Agreements/unsigned`,
      method: 'get',
      baseURL: apiGatewayUrl,
    }).then((response: AxiosResponse<AgreementsApiResponse>) => {
      setAgreements(response.data);
    });
  };

  const handleSendAgreement = useCallback(() => {
    setErrorAcceptedTerm(false);

    if (acceptedTerm) {
      request({
        url: `/api/v1/School/Agreements`,
        method: 'post',
        baseURL: apiGatewayUrl,
        data: {
          productClassAgreementUuid: agreement?.productClassAgreementUuid,
        },
      }).then(() => {
        reFetch();
        clearShowAgreement();
      });
    } else {
      setErrorAcceptedTerm(true);
    }
  }, [acceptedTerm]);

  return (
    <>
      {!!agreementsCount && !!showAgreementProductSlug && !!showAgreementProductClassUuid && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.5)',
            zIndex: 150,
          }}
        >
          <div
            style={{
              position: 'absolute',
              width: '90%',
              maxWidth: 1440,
              height: '80%',
              maxHeight: 768,
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              background: 'white',
              zIndex: 1500,
              borderRadius: 4,
            }}
          >
            <div
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                padding: 40,
                overflowY: 'auto',
                overflowX: 'hidden',
              }}
            >
              <RichContent>{agreement?.agreementContent}</RichContent>

              <Flex mt={30} mb={20} flexWrap="nowrap" alignItems="flex-start">
                <Checkbox
                  type="checkbox"
                  onChange={(e) => {
                    setAcceptedTerm(e.target.checked);
                  }}
                  checked={acceptedTerm}
                  name="optin"
                  id="optin"
                />

                <Typography type="type2" ml={2} pt="2px">
                  <label htmlFor="optin">Declaro que li e aceito o {agreement?.agreementName}</label>
                </Typography>
              </Flex>

              {errorAcceptedTerm && (
                <Typography color="alert_400" fontWeight="bold" mt={20} mb={3}>
                  Você precisa ler e aceitar o {agreement?.agreementName}
                </Typography>
              )}

              <Button onClick={handleSendAgreement}>Enviar</Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default AgreementContent;
